<template>
  <div>
    <label class="d-block">
      {{ $t(`commands.form.${config.name}.label`) }}
    </label>
    <validation-provider
      :name="$t(`commands.data_types.${config.name}`)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        :options="groups"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val.value"
        input-id="id_group"
        :multiple="multiple"
        @input="$emit('input', model)"
      />
      <p class="mb-0 small">{{ $t(`commands.form.${config.name}.hint`) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
    };
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    if (!this.groups.length) {
      store.dispatch("helpdesk_group/getAll");
    }
  },
  computed: {
    groups() {
      return store.getters["helpdesk_group/getSelectedItems"];
    },
  },
};
</script>

<style></style>
